/* eslint-disable no-param-reassign */
export default (state, action) => {
  const { status, sessionHash } = action.payload;
  state.assets[sessionHash] ??= { sessionHash };
  state.assets[sessionHash].status = status;
};
